// extracted by css-extract-rspack-plugin
var _1 = "e1";
var _2 = "gn";
var _3 = "f2";
var _4 = "gp";
var _5 = "gq";
var _6 = "go";
var _7 = "gr";
var _8 = "as";
var _9 = "gs";
var _a = "e0";
var _b = "gt";
export { _1 as "description", _2 as "discountNavigationComponent", _3 as "linkComponent", _4 as "navigationActions", _5 as "navigationBack", _6 as "navigationInfo", _7 as "searchBack", _8 as "standardContainer", _9 as "textContainer", _a as "title", _b as "validityDate" }
